import { useMutation } from 'react-query';
import { REQUEST_ACTIONS } from '~/Constants/Actions.constants';
import { EVENT_SERVICE_URLS } from '~/Constants/Urls.constants';
import { requestReactQuery } from '~/Helpers/ReactQuery.helper';
import { IErrorResponse } from '~/Models/DTO/Error.models';
import { routeReplacer } from '~/Helpers/String.helper';
import { UscIntegrationDates } from '~/Models/DTO/Integration.model';

interface IModifyDate {
  clientId: string;
  startDate: string;
  endDate: string;
  name?: string;
}

export const useRequestUpdateIntegrationDates = (providerId: string) =>
  useMutation<UscIntegrationDates, IErrorResponse, IModifyDate>(
    [REQUEST_ACTIONS.GET_INTEGRATION_DATES, providerId],
    async (params: IModifyDate) =>
      await requestReactQuery<UscIntegrationDates>({
        url: routeReplacer(EVENT_SERVICE_URLS.EDIT_INTEGRATION_DATES, { providerId }),
        config: { method: 'PUT' },
        data: params,
      }),
  );
